export const useGetQueryParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const entries = Array.from(urlParams.entries());
    return Object.fromEntries(entries);
}
